import { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_URL } from '../utils/constant';

const TallyXMLDownloadButton = () => {
    const [downloading, setDownloading] = useState(null);

    const companyID = localStorage.getItem('companyID');
    const BASE_URL = `${API_URL}/tally`;

    const apis = [
        { key: 'company', name: 'Company Setup (Session XML)', url: `${BASE_URL}/company/${companyID}` },
        { key: 'ledgers', name: 'Tax & Cash Ledgers (P&L)', url: `${BASE_URL}/ledgers/${companyID}` },
        { key: 'suppliers', name: 'Suppliers (Sundry Creditors)', url: `${BASE_URL}/suppliers/${companyID}` },
        { key: 'customers', name: 'Customers (Sundry Debtors)', url: `${BASE_URL}/customers/${companyID}` },
        { key: 'stock', name: 'Stock Items', url: `${BASE_URL}/stock-items/${companyID}` },
        { key: 'purchase', name: 'Purchase Vouchers', url: `${BASE_URL}/purchase-vouchers/${companyID}` },
        { key: 'sales', name: 'Sales Vouchers', url: `${BASE_URL}/sales-vouchers/${companyID}` },
        { key: 'payments', name: 'Supplier Payments', url: `${BASE_URL}/supplier-payments/${companyID}` },
        { key: 'expenses', name: 'Expense Vouchers (Direct & Indirect)', url: `${BASE_URL}/expense-vouchers/${companyID}` },
    ];

    const downloadXML = async (api) => {
        try {
            setDownloading(api.key);

            const res = await axios.post(
                api.url,
                { mode: 'download' },
                { responseType: 'blob' }
            );

            const blob = new Blob([res.data], { type: 'application/xml' });
            const link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);
            link.download = `${api.key}.xml`;
            document.body.appendChild(link);
            link.click();
            link.remove();

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `${api.name} XML downloaded`,
                showConfirmButton: false,
                timer: 3000,
            });

        } catch (error) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to download ${api.name}`,
                showConfirmButton: false,
                timer: 4000,
            });
        } finally {
            setDownloading(null);
        }
    };

    return (
        <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
            <a
                href="#0"
                className="dropdown-toggle nav-link select-store show"
                data-bs-toggle="dropdown"
                aria-expanded="true"
            >
                <span>
                    <span className="user-detail d-inline-flex align-items-center">
                        <i className="ti ti-download me-1" />
                        <span className="tally-btn-full">Download Tally XML</span>
                        <span className="tally-btn-compact d-none">Tally XML</span>
                    </span>
                </span>
            </a>
            <div
                className="dropdown-menu dropdown-menu-right"
                style={{
                    position: "absolute",
                    inset: "0px auto auto 0px",
                    margin: 0,
                    transform: "translate3d(0px, 35px, 0px)"
                }}
                data-popper-placement="bottom-start"
            >
                {apis.map((api) => (
                    <button
                        key={api.key}
                        className="dropdown-item d-flex align-items-center"
                        onClick={() => downloadXML(api)}
                        disabled={downloading}
                    >
                        <i
                            className={`ti ${downloading === api.key
                                    ? 'ti-loader-2 spin'
                                    : 'ti-file-download'
                                } me-2`}
                        />
                        {api.name}
                    </button>
                ))}
            </div>
        </li>
    );
};

export default TallyXMLDownloadButton;
